import Header from "@/reusable_sections/Header";
import PageHero from "@/components/PageHero";
import ServiceIntro from "@/components/service/ServiceIntro";
import ServiceCards from "@/components/service/ServiceCards";
import TreeSurgeonQuote from "./sections/TreeSurgeonQuote";
import OtherServices from "@/components/service/OtherServices";
import CtaBand from "@/components/CtaBand";
import Footer from "@/reusable_sections/Footer";
import { Search, Focus, ShieldCheck, Fingerprint, FileSearch, CarFront } from "lucide-react";
const treeServices = [{
  title: "Tree Felling & Removal",
  description: "Safe and controlled removal of hazardous trees across Southampton gardens using specialist rigging and sectional dismantling techniques.",
  icon: Search
}, {
  title: "Pruning & Crown Reduction",
  description: "Careful reduction of the tree canopy to allow more natural light into your Southampton home while decreasing wind stress on roofs.",
  icon: Focus
}, {
  title: "Crown Lifting & Thinning",
  description: "Selective trimming of lower branches and dense inner limbs to protect gutters, rooflines, and walkways around Southampton properties.",
  icon: ShieldCheck
}, {
  title: "Stump Grinding & Removal",
  description: "Complete elimination of tree stumps below ground level across Southampton, clearing space for turfing, paving, or landscaping.",
  icon: Fingerprint
}, {
  title: "Hedge Trimming & Tree Care",
  description: "Precision trimming, shaping, and health management to keep domestic hedges and mature boundary trees tidy and robust throughout Hampshire.",
  icon: FileSearch
}, {
  title: "Emergency Tree Work",
  description: "Rapid assistance for fallen branches or storm-damaged trees that threaten property, driveways, or roof structures in Southampton.",
  icon: CarFront
}];
export default function TreeSurgeonPage() {
  return <div className="min-h-screen bg-background text-foreground flex flex-col">
      <Header />

      <PageHero breadcrumbLabel="Tree Surgeon" breadcrumbParent={{
      label: "Services",
      to: "/ServicesHubPage"
    }} eyebrow="SOUTHAMPTON ARBORICULTURAL CARE" title="Tree Surgeon in Southampton" intro="Professional tree surgery and maintenance services delivered with precision, safety, and care for homeowners across Southampton, Hampshire & surrounding areas." imageSrc="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662274/img/tree_surgeon_working_at_height.png" imageAlt="Professional tree surgeon in Southampton carrying out tree maintenance" actions={true} />

      <ServiceIntro eyebrow="EXPERT TREE CARE" heading="Trusted Tree Surgery & Maintenance in Southampton" paragraphs={["Looking for a reliable tree surgeon in Southampton? Firststop Roofing Ltd provides comprehensive arboricultural and exterior property services, from precision pruning and crown reduction to sectional tree felling and stump grinding.", "Our experienced team works with meticulous care, modern safety rigging, and full respect for nearby roofs, fences, and outbuildings, serving Southampton, Hampshire & surrounding areas including Totton, Eastleigh, and Romsey."]} benefits={["Controlled tree felling and precision sectional dismantling in confined garden spaces", "Canopy thinning and crown lifting to safeguard roofing, gutters, and boundary lines", "Clean stump grinding below surface grade with full debris and woodchip removal"]} imageSrc="https://qualityroofsandlandscapes.co.uk/wp-content/uploads/2026/05/tree-surgeon-on-tree.jpg" imageAlt="Tree surgeon working safely on a mature tree in Southampton" cta={true} />

      <ServiceCards eyebrow="ARBORICULTURAL SERVICES" heading="Complete Tree Care Solutions in Southampton" intro="Tailored tree surgery designed to protect your home, enhance garden light, and keep grounds immaculate across Southampton, Hampshire & surrounding areas." items={treeServices} columns={3} />

      <TreeSurgeonQuote />

      <OtherServices currentKey="tree-surgeon" />

      <CtaBand />

      <Footer />
    </div>;
}